'use strict';

((window, document, undefined, obj) => {

    // Keep transitions off until the page has fully loaded and web fonts are
    // ready, so elements don't visibly fly into place while layout is still
    // settling on slow connections. Falls back to a timeout in case `load` or
    // `fonts.ready` never resolve.
    // `booting` (see style.scss) is removed by Portal.lib.module.js once the Blazor
    // circuit has replaced the prerendered markup; the timeout here is a fallback
    // for when the circuit never connects.
    // Only touch the attribute when a class is actually there: `classList.remove()`
    // rewrites the class attribute regardless, which queues another mutation record and
    // would make the observer below retrigger itself endlessly.
    const done = { preload: false, booting: false };
    const removeClasses = () => {
        const classList = document.documentElement.classList;

        if (window.portalBooted)
            done.booting = true;

        Object.keys(done).forEach(name => {
            if (done[name] && classList.contains(name))
                classList.remove(name);
        });
    };

    // Blazor's enhanced navigation patches <html> back to the server-rendered markup on
    // every in-app navigation, so `preload` and `booting` return and would keep
    // transitions and animations switched off until the next full page load. Watch for
    // them coming back.
    let watching = false;
    const finish = name => {
        done[name] = true;
        removeClasses();

        if (watching)
            return;

        watching = true;
        new MutationObserver(removeClasses).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    };

    const loaded = new Promise(resolve => window.addEventListener('load', resolve, { once: true }));
    const fontsReady = (document.fonts && document.fonts.ready) || Promise.resolve();
    Promise.all([loaded, fontsReady]).then(() => finish('preload'));
    setTimeout(() => finish('preload'), 4000);
    setTimeout(() => finish('booting'), 6000);

    helper.event(document, 'scroll', scroll.init);
    autosize.init();

})(window, document, undefined, {
    helper,
    scroll,
    autosize
});
